import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component } from '@angular/core'
import { AppSidebarService } from 'main/services/appSidebar.service'
import { UploaderService } from 'main/services/uploader.service'
import { RouteLoggerService } from '../../common/util/services/routeLogger.service'

export const routeChangingTrigger = trigger('routeChanging', [
  state('true', style({ transform: 'translateX(-50px)', opacity: 0 })),
  state('false', style({ transform: 'translateX(0)', opacity: 1 })),
  transition('false => true', [
    animate('125ms ease-out'),
  ]),
  transition('true => false', [
    style({ transform: 'translateX(50px)', opacity: 0 }),
    animate('125ms ease-out'),
  ]),
])

@Component({
  selector: 'app-root',
  templateUrl: './appRoot.component.pug',
  styleUrls: ['./appRoot.component.scss'],
  animations: [routeChangingTrigger],
})
export class AppRootComponent {
  constructor (
    public uploader: UploaderService,
    public appSidebar: AppSidebarService,
    public routeLogger: RouteLoggerService,
  ) {
    document.addEventListener('click', () => {
      if (document.activeElement?.tagName === 'BUTTON') {
        document.activeElement['blur']?.()
      }
    })
  }

  collapseSidebar () {
    if (!this.appSidebar.collapsed && window['mobileMode']) {
      this.appSidebar.toggle()
    }
  }
}
